import './table-view-switch.less';

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import { tableViewType } from '../list';
import ControlSwitchSingleDecorator from '../../shared/switch-control/single/main';

const propTypes =  {
	table: PropTypes.object,
	switchTableView: PropTypes.func,
	statusesFilters: PropTypes.array
};

const TableViewSwitch = ({
	table,
	switchTableView,
	statusesFilters
}) => {
	const shouldDisabled = !!statusesFilters.filter(
		entity => entity.active && (entity.name === 'closed' || entity.name === 'paused')
	).length;

	return (
		<ControlSwitchSingleDecorator className="ext-threads-table-view-switch">
			<button
				onClick={() => switchTableView(tableViewType.group)}
				disabled={shouldDisabled}
				className={cn('ui-btn ui-btn-secondary icon-group-view', table.view === tableViewType.group && 'active')} />
			<button
				onClick={() => switchTableView(tableViewType.list)}
				disabled={shouldDisabled}
				className={cn('ui-btn ui-btn-secondary icon-list-view', table.view === tableViewType.list && 'active')} />
		</ControlSwitchSingleDecorator>
	);
};

TableViewSwitch.propTypes = propTypes;

export default TableViewSwitch;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/components/table-view-switch.js